function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
/**
 * Purpose: IMPORTFIELD opcode — verify a signed witness value and store it
 * under `key` in context.__opcodes.importfield.
 *
 * Language shape (KEY / VALUE):
 *   script.key           — variable name to create
 *   witness.value        — imported value
 *   witness.signature    — authorizes that value
 *   script.hash          — contextual binding (unchanged)
 *
 * digest = HASH(value | binding_hash)
 */

module.exports = {
  name: 'IMPORTFIELD',
  description: "\nImports a signed value into VARS under a named key.\n\nVerifies that witness.value was signed by an authorized publickey over a\nbinding hash (literal or VAR reference), then writes the value into\ncontext.__opcodes.importfield[key].\n\nTypical use:\n- import subscription duration\n- import tier, scope, flags, etc.\n",
  exampleScript: {
    op: 'IMPORTFIELD',
    key: 'duration',
    publickey: '__opcodes.checkownnftwhere.creator',
    hash: '__opcodes.checkownnftwhere.nft_id',
    witness: {
      value: '<integer>',
      signature: '<hex_signature>'
    }
  },
  execute: function execute(node, context) {
    if (!node || _typeof(node) !== 'object' || !context || _typeof(context) !== 'object') {
      return false;
    }
    if (!context.app || !context.app.crypto || typeof context.app.crypto.hash !== 'function' || typeof context.app.crypto.verifyMessage !== 'function') {
      return false;
    }
    var key = node.key;
    if (typeof key !== 'string' || key.length === 0) {
      return false;
    }
    var witness = node.witness;
    if (!witness || _typeof(witness) !== 'object' || Array.isArray(witness)) {
      return false;
    }
    var signer_pubkey = node.publickey;
    if (typeof signer_pubkey === 'string') {
      signer_pubkey = resolveRef(context, signer_pubkey);
    }
    var binding_hash = node.hash;
    if (typeof binding_hash === 'string') {
      binding_hash = resolveRef(context, binding_hash);
    }
    if (typeof signer_pubkey !== 'string' || signer_pubkey.length === 0) {
      return false;
    }
    if (typeof binding_hash !== 'string' || binding_hash.length === 0) {
      return false;
    }
    var value = witness.value;
    if (typeof value === 'string') {
      value = resolveRef(context, value);
    }
    var signature = witness.signature;
    if (typeof signature === 'string') {
      signature = resolveRef(context, signature);
    }
    if (typeof value !== 'string' && typeof value !== 'number') {
      return false;
    }
    if (typeof signature !== 'string' || signature.length === 0) {
      return false;
    }
    var canonical_string = String(value) + '|' + binding_hash;
    var digest = context.app.crypto.hash(canonical_string);
    if (context.app.crypto.verifyMessage(digest, signature, signer_pubkey) !== true) {
      return false;
    }
    if (!context.__opcodes) {
      context.__opcodes = {};
    }
    if (!context.__opcodes.importfield) {
      context.__opcodes.importfield = {};
    }
    context.__opcodes.importfield[key] = value;
    return true;
  }
};
function resolveRef(root, ref) {
  if (typeof ref !== 'string') {
    return ref;
  }
  var parts = ref.split('.');
  var cursor = root;
  for (var i = 0; i < parts.length; i += 1) {
    var key = parts[i];
    if (!cursor || _typeof(cursor) !== 'object' || !Object.prototype.hasOwnProperty.call(cursor, key)) {
      return ref;
    }
    cursor = cursor[key];
  }
  return cursor;
}